import { createAction } from '@reduxjs/toolkit';

export const createThematicTagContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>('CreateThematicTagContainer/NavigateTo'),
};
